<ng-template #defaultButton>
  <button
    type="button"
    (click)="!disabled() ? dropdownHidden.set(!dropdownHidden()) : null"
    class="w-full h-full bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-500 focus:border-primary-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
    [class.cursor-not-allowed]="disabled()"
    [ngClass]="overwriteButtonStyle()"
  >
    <div
      [class.justify-between]="selectedLabel()"
      [class.justify-end]="!selectedLabel()"
      class="min-h-5 min-w-0 flex items-center"
    >
      <span class="truncate">{{ selectedLabel() }}</span>
      <svg
        class="w-2.5 h-2.5 ms-3 shrink-0"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 10 6"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 4 4 4-4"
        />
      </svg>
    </div>
  </button>
</ng-template>

<div class="relative h-full w-full">
  <div class="relative w-full">
    @if (customButtonTemplate()) {
      <button
        type="button"
        (click)="!disabled() ? dropdownHidden.set(!dropdownHidden()) : null"
        [class.cursor-not-allowed]="disabled()"
      >
        <ng-container *ngTemplateOutlet="customButtonTemplate()">
        </ng-container>
      </button>
    } @else {
      <ng-container *ngTemplateOutlet="defaultButton"></ng-container>
    }
    @if (disabled()) {
      <div
        class="absolute inset-0 bg-black/5 dark:bg-black/20 rounded-lg cursor-not-allowed"
      ></div>
    }
  </div>

  <!-- Dropdown menu -->
  @if (!this.dropdownHidden()) {
    <div
      [animate.enter]="
        dropdownPlacement() === 'bottom' ? 'animate-enter-down' : (
          'animate-enter-up'
        )
      "
      [animate.leave]="
        dropdownPlacement() === 'bottom' ? 'animate-leave-down' : (
          'animate-leave-up'
        )
      "
      class="absolute z-10 bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-500 focus:border-primary-500 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-500 dark:focus:border-primary-500 transition-all"
      [ngClass]="[
        dropdownPlacement() === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2',
        dropdownXPlacement() === 'right' ? 'start-0' : 'end-0',
        overwriteStyle(),
      ]"
      (wheel)="$event.stopPropagation()"
      (touchmove)="$event.stopPropagation()"
    >
      @if (useSearch()) {
        <div class="p-3">
          <div class="relative">
            <div
              class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none"
            >
              <svg
                class="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="text"
              [attr.aria-label]="searchPlaceholder()"
              class="w-full p-2 ps-10 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              [placeholder]="searchPlaceholder()"
              [formControl]="searchControl"
            />
          </div>
        </div>
      }
      <ul
        class="max-h-[10rem] px-3 py-2 dark:text-white overflow-auto"
        role="listbox"
      >
        @for (option of filteredOptions$ | async; track trackByKey(option)) {
          <li
            [ngClass]="{
              'bg-gray-300 dark:bg-gray-800': selectedOption() === option,
              'bg-white dark:bg-gray-700': selectedOption() !== option,
            }"
            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg"
            role="option"
          >
            <div
              class="w-full text-left p-2 rounded-sm"
              role="option"
              type="button"
              (click)="onClickOption(option)"
            >
              <span
                class="inline-block font-medium text-gray-900 dark:text-gray-300"
              >
                {{ getLabel(option) }}
              </span>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>
